import { ChangeDetectorRef, Component, forwardRef, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { _HttpClient } from '@delon/theme';

import { SelectBaseComponent } from '../select-base';

@Component({
  selector: 'app-bir-class-select',
  templateUrl: './bir-class-select.component.html',
  styles: [
    `
      [nz-icon] {
        cursor: pointer;
      }
      [nz-select] {
        width: 180px;
      }
    `
  ],
  standalone: false,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => BirClassSelectComponent),
      multi: true
    }
  ]
})
export class BirClassSelectComponent extends SelectBaseComponent {
  @Input() type: 'both' | 'customer' | 'supplier' = 'both';

  constructor(http: _HttpClient, cdr: ChangeDetectorRef) {
    super(http, cdr);
    this.valueField = '';
  }

  getUrl(searchValue: string): string {
    let filter = '';
    // if (this.type === 'customer') {
    //   filter =
    //     '(isAR eq true and isAP eq false) or (isAR eq true and isAP eq true)';
    // } else if (this.type === 'supplier') {
    // filter =
    //   '(isAP eq true and isAR eq false) or (isAP eq true and isAR eq true)';
    // }

    if (searchValue) {
      const searchFields = [
        'code',
        'companyName',
        'firstName',
        'middleName',
        'lastName',
        'tinNumber',
        'tinBranchCode',
        'address'
      ];
      const searchStr = searchValue.replaceAll("'", "''");
      const searchFilter = searchFields
        .map(x => `contains(${x}, '${encodeURIComponent(searchStr)}')`)
        .join(' or ');

      if (filter) {
        filter += ` and (${searchFilter})`;
      } else {
        filter = `(${searchFilter})`;
      }
    }

    let url = `api/BIRClassifications/Query?$top=20&$skip=0&$orderby=code asc`;

    if (filter) {
      url += `&$filter=${filter}`;
    }

    return url;
  }
}
